import { IonThumbnail, IonSkeletonText } from '@ionic/react';

import { Card } from '../../../Card/Card';

import styles from '../../Skeleton.module.scss';

export const SkeletonBaseSmall = () => (
  <Card variant="flat" className={styles.baseRoot}>
    <Card.Content>
      <div className={styles.baseContent}>
        <IonThumbnail className={styles.baseThumbnail}>
          <IonSkeletonText className={styles.skeleton} animated />
        </IonThumbnail>
        <div className={styles.baseText}>
          <IonSkeletonText className={styles.skeleton} animated />
          <IonSkeletonText className={styles.skeleton} animated />
        </div>
      </div>
    </Card.Content>
  </Card>
);
